// @ts-nocheck
/* eslint-disable */
export const appVehicleSocNoIssues32Icon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="15.8164" r="7" stroke="currentColor" stroke-width="2"/><line x1="10.9179" y1="20.8373" x2="20.5429" y2="11.2123" stroke="currentColor" stroke-width="2"/></svg>`,
    name: 'vehicle-soc-no-issues-32' as const
};